// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"73877e92","453":"994774f0","732":"ab422603","901":"428ded9c","977":"1a0a02ce"}[chunkId] + ".chunk.js";
};